// extracted by mini-css-extract-plugin
export default {"base":"rAf5K","border":"lsOk5"};